import { Card, CardTitle, CardText, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import './CardStyle.css';

function AlertCard(props) {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/");
    }

    return (
        <Card body style={{
            maxWidth: '35rem'
        }} >
            <CardTitle className="d-flex justify-content-center" tag="h5">
                {props.title}
            </CardTitle>
            <CardText className="d-flex justify-content-center">
                {props.text}
            </CardText>
            <div className="d-flex justify-content-center">
                <Button className=" secondary-button"
                    style={{
                    }} onClick={handleClick}>
                    {props.buttonText}
                </Button>
            </div>
            { props.children }
        </Card>
    );
}

export default AlertCard;